import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { ManagedTransportationMasterServicesAgreement } from '@/screens/Legal/ManagedTransportationMasterServicesAgreement';

export default function ManagedTransportationMasterServicesAgreementPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics service agreement, managed transportation service agreement,"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title="Managed Transportation Master Services Agreement | Loadsmart"
        description="Managed Transportation Master Services Agreement at Loadsmart"
        canonical="https://loadsmart.com/managed-transportation-master-services-agreement/"
        openGraph={{
          url: 'https://loadsmart.com/managed-transportation-master-services-agreement/',
        }}
      />
      <ManagedTransportationMasterServicesAgreement />
    </>
  );
}
